import { Accordion, AccordionDetails, AccordionSummary, Typography, Checkbox, Button, Badge, makeStyles, CircularProgress, Grid, Menu, MenuItem, Chip } from "@material-ui/core"
import { ExpandMore, Fullscreen, PriorityHigh } from "@material-ui/icons"
import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getDriverOrders, getZipCodeBoundary } from "../../../actions/mmActions"
import { removeMarker } from "../../../reducers/mapMarkerSlice"
import { stripIdFromStaffName, getDistrictName, getUserPreference} from "../../../utilities/common"
import _ from 'lodash'
import { addSelectedOrder, removeSelectedOrders, getSelectedBatchIds, handleTransferOrdersDialog, addSelectedAccounts, getSelectedOrders, handleOrderFilterDialog, handleEditOrderModal, getSelectedAccounts, resetSelectedOrders, resetSelectedAccounts, getScrollToOrderId, setProblemOrders, getOpenProblemOrderDialog, handleOpenProblematicOrdersDialog, setSelectedOrders, showAlertSnackbar } from "../../../reducers/uiSlice"
import { useTranslation } from "react-i18next"
import { changeParcelStatusFilter, resetOrderFilter } from "../../../reducers/filterSlice"
import { getDriverServicePoint } from "../../../actions/dropOffActions"
import { handleCurrentDriverId } from "../../../actions/mmActions"
import { useToken } from "../../../utilities/hooks"
import FullscreenLoading from "../../Common/FullscreenLoading"

const useStyles = makeStyles((theme)=> ({
    badgeGroupRoot: {
        '& > *': {
          marginLeft: theme.spacing(1),
        },
    },
    badgeWithoutContent: {
        top: 'unset',
        right: 'unset'
    },
    badgeWithoutContentExpress: {
        top: 'unset',
        right: 'unset',
        backgroundColor: 'green',
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 50
    },
    root: {
        zIndex:1200
    },
    orderItem: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%'
    },
    dropOffLocation: {
        marginTop: 14,
        marginBottom: 14,
        fontSize: 16,
        fontWeight: 'bold'
    },
    highlightOrderType: {
        backgroundColor: 'green'
    },
    wrongLocationOrder: {
        backgroundColor: 'blue'
    }
}))

const initialMousePos = {
    mouseX: null,
    mouseY: null
}

const SelectionType = {
    ACCOUNT: "account",
    DISTRICT: "district",
    INDIVIDUAL: "individual",
    TRACKING_CODE: "tracking_code",
    REMOVE: "remove",
    ROUTE: "route"
}

const initialContextMenuState = false

function SelectableOrderInfo(props){
    const classes = useStyles()
    const {t} = useTranslation('mapManagement');
    let {data, index, areaExpanded} = props
    const tokenContents = useToken();

    const userUS = tokenContents.userUS;

    const filterChange = useSelector(state => state.mapManagement.filterChange);
    const dispatch = useDispatch();
    let userPref = getUserPreference();
    let selectedBatchIds = useSelector(getSelectedBatchIds);
    let selectedOrders = useSelector(getSelectedOrders);
    let selectedAccounts = useSelector(getSelectedAccounts);
    const scrollToOrderId = useSelector(getScrollToOrderId);
    const isProblemOrderDialogOpen = useSelector(getOpenProblemOrderDialog);
    const currentDriverId = useSelector(state=>state.mapManagement.driverId);

    const [expandAccordion, setExpandAccordion] = useState(false);
    // const [checked, setChecked] = useState([]);
    // const [prevChecked, setPrevChecked] = useState([]);
    const [allChecked, setAllChecked] = useState([]);
    const [mousePos, setMousePos] = useState(initialMousePos);
    const [contextMenuOpen, setContextMenuOpen] = useState(initialContextMenuState);
    const [contextSelectOrder, setContextSelectOrder] = useState();
    const [filter, setFilter] = useState({});

    const [dropOffName, setDropOffName] = useState();

    // Display zip boundaries
    const [geoJsonDisplay, setGeoJsonDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const layersGeojson = useRef([]);

    //let prevChecked = usePrevious(checked)
    let districtOrders = filterDistrictOrders(props.staffOrders, props.filter)
    let orderList = _.flatten(_.values(districtOrders))

    const contextMenuRef = useRef()
    let orderListItemRef = orderList.reduce((order, value)=>{
        order[value.order_id] = React.createRef()
        return order
    }, {})

    useEffect(() => {
        if(scrollToOrderId && _.has(orderListItemRef, scrollToOrderId))
            handleScrollToOrder(scrollToOrderId)
    }, [scrollToOrderId])

    useEffect(() => {
        if(!areaExpanded){
            handleOrderSelection(SelectionType.REMOVE)
        }
    }, [areaExpanded])

    useEffect(() => {
        if(!props.reset) {
            if(filterChange) {
                if(filterChange.length > 0) {
                    dispatch(
                        changeParcelStatusFilter({
                            driverId: data.id, 
                            ...filterChange[1]
                        })
                    )
                }
            }
        }
    }, [filterChange])
    useEffect(() => {
        if(props.reset) {
            dispatch(resetOrderFilter(data.id))
        }
    }, [props.reset])
    useEffect(() => {
        // '1' -> transfer by route
        if(currentDriverId === data.id) {
            let currentSelectedOrders = _.cloneDeep(selectedOrders);
            if(props.transferType === '1') {
                if(props.routeInfo) {
                    if(props.routeInfo.length > 0) {
                        let currentOrderIds = _.map(props.routeInfo, 'order_id');
                        handleOrderSelection(SelectionType.ROUTE, null, currentOrderIds, null, props.routeInfo);
                    }
                }
            }
        }
    }, [props.transferType, props.routeInfo])
    
    const handleZipBoundaryView = (id) => {
        props.clearLayers();
        if(!geoJsonDisplay) {
            setLoading(true);
            let params = {
                route_no: id,
                warehouse: userPref.userCity
            }
            dispatch(getZipCodeBoundary(params))
            .then((jsonData) => {
                if(jsonData?.length > 0) {
                    jsonData.forEach((data) => {
                        var dataLayer = new window.google.maps.Data({map: window.googleMapInstance});
                        dataLayer.setStyle({
                            strokeColor: "green"
                        })
                        layersGeojson.current.push({
                            layer: dataLayer,
                            geoJson: dataLayer.addGeoJson(JSON.parse(data.area_json))
                        })
                    })
                    props.addLayers(layersGeojson.current);
                } else {
                    dispatch(showAlertSnackbar({message:t('no_boundary_info'),type:'info'}))
                }
            })
            .catch(() => {
                dispatch(showAlertSnackbar({message:t('no_data_contact_it'),type:'error'}))
            })
            .finally(() => {
                setLoading(false);
            })
        }
        setGeoJsonDisplay(!geoJsonDisplay);
    }

    return (
        <div style={{width: '100%'}}>
            <Accordion
            TransitionProps={{ unmountOnExit: true, timeout: 0 }}
            expanded={ data.order_count !== 0 && data.order_count !== undefined && expandAccordion ? expandAccordion: false}
            onChange={(event, expanded)=>handleAccordionExpandChange(data.id, event, expanded)}
            >
                <AccordionSummary
                    expandIcon={data.order_count !== 0 && data.order_count !== undefined ? <ExpandMore /> : null}
                    aria-label="accountListExpand"
                    aria-controls={"accordion-content-" + index}
                    id={`accordion-row-${data.id}`}
                >
                    <Typography>{`${data.id}.${stripIdFromStaffName(data.name)}`} {props.showPhoneNumber? `[${data.phone}]`: null}</Typography>
                    <div className={classes.badgeGroupRoot}>
                        {   
                            getOrderCount(data.order_count, data.route_planned_count) !== 0 &&
                            <Chip 
                                label={getOrderCount(data.order_count, data.route_planned_count)}
                                size='small'
                                style={{ backgroundColor: 'red', color: "white" }}
                            />
                        }
                        {   
                            getOrderCountExpress(data.express_count) !== 0 &&
                            <Chip 
                                label={getOrderCountExpress(data.express_count)}
                                size='small'
                                style={{ backgroundColor: 'green', color: "white" }}
                            />
                        }
                        {   
                            userUS &&
                            data?.route_planner_distance &&
                            <Chip 
                                label={data?.route_planner_distance + t('distance_unit')}
                                size='small'
                                style={{ backgroundColor: 'blue', color: "white" }}
                            />
                        }
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    {props.loading ? 
                        <div className={classes.orderItem}><CircularProgress color='secondary'/></div>
                        : 
                        <div className={classes.orderItem}>
                            <Grid container spacing={1} style={{paddingBottom: 12}}>
                                <Grid item xs={4}>
                                    <Button 
                                    variant="contained" 
                                    color='secondary' 
                                    size='small' 
                                    fullWidth 
                                    onClick={() => {
                                        handleOrderSelection(SelectionType.ACCOUNT);
                                        dispatch(handleCurrentDriverId(data.id));
                                    }}
                                    >
                                        {selectedOrders.length === orderList.length ? t('deselect_all') : t('select_all')}
                                    </Button>
                                </Grid>
                                <Grid item xs={4}>
                                    <Button variant="contained" color='secondary' size='small' fullWidth onClick={()=>{handleOrderSelection(SelectionType.TRACKING_CODE, null, null, 200)}}>{t('select_scanned')}</Button>
                                </Grid>
                                {/* <Grid item xs={4}>
                                    <Button variant="contained" color='secondary' size='small' fullWidth onClick={()=>{handleOrderSelection(SelectionType.TRACKING_CODE, null, null, 192)}}>{t('select_not_released')}</Button>
                                </Grid> */}
                                <Grid item xs={4}>
                                    <Button variant="contained" color='secondary' size='small' fullWidth onClick={()=>{handleZipBoundaryView(data.id)}}>{t('view_zip_boundary')}</Button>
                                </Grid>
                                <Grid item xs={4}>
                                    <Button variant="contained" color='secondary' size='small' fullWidth onClick={()=>handleTransferOrder(data.id)}>
                                        {t('transfer_orders')}
                                    </Button>
                                </Grid>
                                <Grid item xs={4}>
                                    <Button 
                                        variant="contained" 
                                        color='secondary' 
                                        size='small' 
                                        fullWidth
                                        endIcon={getIsFilterActive() ? <PriorityHigh size='small' /> : null}
                                        onClick={()=>dispatch(handleOrderFilterDialog({open: true, driverId: data.id}))}
                                        disabled={props.weightFilterTotal}
                                    >
                                        {t('order_filter')}
                                    </Button>
                                </Grid>
                                <Grid item xs={4}>
                                    <Button 
                                        variant="contained" 
                                        color='secondary' 
                                        size='small' 
                                        fullWidth
                                        onClick={()=>{
                                            props.handleAccountListDropOff('');
                                            dispatch(getDriverServicePoint(data.id))
                                            .then((res) => {
                                                setDropOffName(res.name)
                                                props.handleAccountListDropOff(res.name);
                                                props.handleServicePointViewOpen(!props.servicePointViewOpen)
                                            })
                                            .catch((err) => {
                                                setDropOffName(t('not_set_yet'));
                                                props.handleServicePointViewOpen(!props.servicePointViewOpen)
                                            })
                                            
                                        }}
                                    >
                                        {t('service_point')}
                                    </Button>
                                </Grid>
                            </Grid>
                            <div className={classes.dropOffLocation}>
                                {t('drop_off_location') + dropOffName}
                            </div>
                            {_.map(districtOrders, function(orders, key){
                                return (
                                    <div key={key} >
                                        <div style={{display: 'flex'}}>
                                            <Checkbox
                                                checked={allChecked.indexOf(key) !== -1}
                                                onChange={()=>{
                                                    props.handleServicePointViewOpen(false);
                                                    handleOrderSelection(SelectionType.DISTRICT, key)
                                                    window.localStorage.setItem('transfer-all', allChecked.indexOf(key) === -1 ? 1 : 0);
                                                    dispatch(handleCurrentDriverId(data.id));
                                                }}
                                                style={{paddingRight: 8, alignSelf: 'center'}}
                                            />
                                            <Typography 
                                                variant='h6' 
                                                align='center' 
                                                style={{
                                                    width: '100%', 
                                                    fontWeight: 'bold', 
                                                    textTransform: 'uppercase'
                                                }}
                                            >
                                                {getDistrictName(key)} ({orders.length})
                                            </Typography>
                                        </div>
                                        {orders.map((order, index) => {
                                            return (
                                                <div 
                                                    style={scrollToOrderId === order.order_id ? 
                                                        {
                                                            display: 'flex', 
                                                            padding: '8 8 8 0', 
                                                            border: '2px solid red',
                                                            borderRadius: 8
                                                        }
                                                        :
                                                        {
                                                            display: 'flex'
                                                        }
                                                    }
                                                    className={order.isWrongLocation ? classes.wrongLocationOrder : (order.express_type?classes.highlightOrderType : classes.normalOrderType)}
                                                    key={index} 
                                                    ref={orderListItemRef[order.order_id]}
                                                >
                                                    <div style={{alignSelf: 'center'}}>
                                                        <Checkbox
                                                            checked={selectedOrders.indexOf(order.order_id) !== -1}
                                                            onChange={(event)=> {
                                                                props.handleServicePointViewOpen(false);
                                                                handleOrderSelection(SelectionType.INDIVIDUAL, null, order.order_id)
                                                                dispatch(handleCurrentDriverId(data.id));
                                                            }}
                                                            className="accountOrderCheckBox"
                                                            style={{paddingRight: 8}}
                                                        />
                                                    </div>
                                                    <div 
                                                        style={{flexDirection: 'column', cursor: 'context-menu'}} 
                                                        onContextMenu={(event)=>handleContextMenuOpen(event, order)}
                                                    >
                                                        <Typography variant='body2'>[{order.tno}] {order.address}</Typography>
                                                        <div>
                                                            <Typography variant='body2'>[{order.path_info}]</Typography>
                                                            <Typography variant='body2' style={{color: 'red'}}>[{t('common:weight')}: {Number(order.total_weight) || 0.00}{t('common:unit_of_weight')}] {order.driver_notes}</Typography>
                                                        </div>
                                                    </div>
                                            </div>
                                        )})}
                                        <Menu
                                            keepMounted
                                            ref={contextMenuRef}
                                            open={mousePos.mouseY !== null && contextMenuOpen}
                                            onClose={handleContextMenuClose}
                                            anchorReference="anchorPosition"
                                            anchorPosition={
                                                mousePos.mouseY !== null && mousePos.mouseX !== null
                                                ? { top: mousePos.mouseY, left: mousePos.mouseX }
                                                : undefined
                                            }
                                            elevation={4}
                                        >
                                            <MenuItem onClick={()=>_handleEditOrderModal()}>{t("edit_order")}</MenuItem>
                                            <MenuItem onClick={()=>handleContextMenuClick()}>{t("edit_driver_notes")}</MenuItem>
                                        </Menu>
                                    </div>
                                )
                            })}
                        </div>
                    }
                </AccordionDetails>
            </Accordion>
            <FullscreenLoading open={loading}/>
        </div>
    )

    function handleAccordionExpandChange(driverId, event, expanded){
        console.log("Account Expand/Collapse")
        props.clearLayers();
        if(getOrderCount(data.order_count) === 0){
            return
        }
        if(expanded) {
            setGeoJsonDisplay(false);
            dispatch(getDriverServicePoint(driverId))
            .then((res) => {
                setDropOffName(res.name)
                props.handleAccountListDropOff(res.name);
            })
            .catch((err) => {
                setDropOffName(t('not_set_yet'));
            })
        }
        setExpandAccordion(!expandAccordion)
        if(expanded && _.isEmpty(districtOrders)){
            dispatch(getDriverOrders(driverId, selectedBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity))
            .then((data)=>{
                let badOrders = getLatLngErrorOrders(data.orders)
                if(badOrders.length > 0){
                    console.log(`Position Error: ${badOrders}`)
                    dispatch(setProblemOrders(badOrders))
                    if(!isProblemOrderDialogOpen){
                        dispatch(handleOpenProblematicOrdersDialog(true))
                    }
                }
            })
        } else if (!expanded){
            //setChecked([])
        }
    }

    function getLatLngErrorOrders(orderList = []){
        let result = []
        _.forEach(orderList, (order)=>{
            if(order.lat === null || order.lat === undefined || Number(order.lat) === 0 ||
                order.lng === null || order.lng === undefined || Number(order.lng) === 0) {
                result.push(order)
            }
        })
        return result
    }

    function handleCheckByDistrict(districtId, currentChecked){
        let currentIndex = allChecked.indexOf(districtId)
        let newAllChecked = [...allChecked]

        if(currentIndex === -1){
            newAllChecked.push(districtId)
            if(_.isEmpty(districtOrders)) return
            let allOrdersByDistrict = districtOrders[districtId]
            let orderIds = _.map(allOrdersByDistrict, 'order_id')
            setAllChecked(newAllChecked)
            return _.union(orderIds, currentChecked)
        } else {
            newAllChecked.splice(currentIndex, 1)
            let allOrdersByDistrict = districtOrders[districtId]
            let orderIds = _.map(allOrdersByDistrict, 'order_id')
            setAllChecked(newAllChecked)
            return _.difference(currentChecked, orderIds)
        }
    }

    function handleIndividualCheck(value, currentChecked){
        let currentIndex = currentChecked.indexOf(value)
        let newChecked = [...currentChecked]

        if(currentIndex === -1){
            newChecked.push(value)
        }else {
            newChecked.splice(currentIndex, 1)
        }
        return newChecked
    }

    function handleCheckByAccount(currentChecked){
        window.localStorage.setItem('transfer-all', currentChecked.length < orderList.length ? 1 : 0);
        if (currentChecked.length < orderList.length){
            //If there are unchecked orders, check them all
            let orderIds = _.map(orderList, 'order_id')
            return _.union(orderIds, currentChecked)
        } else {
            //If all orders are checked, uncheck them all
            return []
        }
    }

    function selectByTrackingCode(currentChecked, trackingCode){
        let ordersWithStatus = _.filter(orderList, (object) => object.path_code == trackingCode)
        if(currentChecked.length < ordersWithStatus.length){
            let orderIds = _.map(ordersWithStatus, 'order_id')
            return _.union(orderIds, currentChecked)
        } else {
            return []
        }
    }

    function handleOrderSelection(type, districtId, order, trackingCode, orderInfo){
        if(type === SelectionType.ROUTE) {
            if(orderInfo) {
                if(orderInfo.length > 0) {
                    dispatch(setSelectedOrders(orderInfo));
                }
            }
            return;
        }
        let _checked = []
        let _prevChecked = _.intersectionWith(selectedOrders, orderList, (num, object) => object.order_id == num)
        switch(type){
            case SelectionType.ACCOUNT:{
                _checked = handleCheckByAccount(_prevChecked)
                break;
            }
            case SelectionType.DISTRICT: {
                _checked = handleCheckByDistrict(districtId, _prevChecked);
                break;
            }
            case SelectionType.INDIVIDUAL: {
                _checked = handleIndividualCheck(order, _prevChecked)
                break;
            }
            case SelectionType.TRACKING_CODE: {
                _checked = selectByTrackingCode(_prevChecked, trackingCode)
                break;
            }
            default:
                break;
        }

        let newChecked = _.difference(_checked, _prevChecked)
        let removeChecked = _.difference(_prevChecked, _checked)

        if(newChecked.length > 0){
            if(_.indexOf(selectedAccounts, data.id) === -1){
                removePrevAccountSelection().then(()=>{
                    checkNewSelection(newChecked)
                })
            } else {
                checkNewSelection(newChecked)
            }
        }
        
        if(removeChecked.length > 0){
            dispatch(removeMarker(removeChecked))
            dispatch(removeSelectedOrders(removeChecked))
        }
    }

    function handleTransferOrder(driverId){
        dispatch(handleTransferOrdersDialog(true))
        dispatch(handleCurrentDriverId(driverId));
    }

    function handleContextMenuOpen(event, order){
        event.preventDefault();
        setContextMenuOpen(true)
        setContextSelectOrder(order)
        setMousePos({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
        })
    }

    function handleContextMenuClose(event){
        console.log("close", contextMenuOpen, mousePos)
        if(contextMenuOpen){
            setContextMenuOpen(initialContextMenuState)
            setMousePos(initialMousePos)
        }
    }

    function _handleEditOrderModal(){
        dispatch(handleEditOrderModal({open: true, orderIdentifier: contextSelectOrder.order_id, type: "order_id"}))
        handleContextMenuClose()
    }

    function handleContextMenuClick(){
        handleContextMenuClose()
    }

    function getOrderCount(orderCount = 0, plannedCount = 0){
        if (_.size(districtOrders) > 0){
            orderCount = _.reduce(districtOrders, (result, array, key) =>{
                return result + array.length
            }, 0)
        }
        
        if (orderCount === 0) return 0
        if (orderCount > 0 && plannedCount === 0) return orderCount
        if (orderCount > 0 && plannedCount > 0) return `${plannedCount}/${orderCount}`

        return 0
    }
    function getOrderCountExpress(orderCountExpress = 0){
        if(expandAccordion) {
            orderCountExpress = 0;
            if(_.size(districtOrders) > 0) {
                for (const key in districtOrders) {
                    districtOrders[key].map((serviceNo) => {
                        if(serviceNo.express_type === 1) {
                            orderCountExpress++;
                        }
                    })
                }
            }
        }
        return orderCountExpress;
    }

    function filterDistrictOrders(staffOrders, filter){
        let result = {}
        _.forEach(staffOrders, (orders, key) => {
            result[key] = getFilteredOrders(orders, filter)
        })
        return result
    }

    function getFilteredOrders(orders, filter){
        if(!orders) return []
        if(!filter) return orders
        let statusFilterActive = filter.parcelStatus.length > 0
        let weightFilterActive = filter.parcelWeight.length > 0

        if(!statusFilterActive && !weightFilterActive) return orders

        return _.filter(orders, (order)=>{
            let statusFilter = true
            let weightFilter = true
            if(statusFilterActive){
                statusFilter = _.includes(filter.parcelStatus, order.path_info)
            }
            if(weightFilterActive){
                let weight = Number(order.total_weight) || 0
                weightFilter = false
                _.forEach(filter.parcelWeight, parcelWeight => {
                    if(weight >= parcelWeight.minWeight && weight <= parcelWeight.maxWeight){
                        weightFilter = true
                    }
                })
            }

            if(statusFilter && weightFilter) return true
        })
    }

    function getIsFilterActive(){
        if(props.filter === null || props.filter === undefined) return false
        if(props.filter.parcelStatus.length > 0) return true
        if(props.filter.parcelWeight.length > 0) return true
    }

    function checkNewSelection(newChecked){
        dispatch(addSelectedOrder(newChecked))
        dispatch(addSelectedAccounts([data.id]))
        let orderArray = orderList;
        let orders = _.intersectionWith(orderArray, newChecked, (o, id)=> o.order_id === id)
        //dispatch(addNewOrderMarkers(orders))

        setMapCenter(calculateMapCenter(orders))
    } 

    async function removePrevAccountSelection(){
        await dispatch(resetSelectedOrders());
        await dispatch(resetSelectedAccounts());
        //await dispatch(resetOrderMarker());
    }

    function calculateMapCenter(orders){
        let bounds = new window.google.maps.LatLngBounds();
        _.forEach(orders, (order)=> {
            bounds.extend(new window.google.maps.LatLng(Number(order.lat) || 0, Number(order.lng) || 0))
        })
        return bounds.getCenter()
    }

    function setMapCenter(LatLng){
        if(window.googleMapInstance){
            window.googleMapInstance.setCenter(LatLng)
        }
    }

    function handleScrollToOrder(id){
        if(orderListItemRef[id] && _.has(orderListItemRef[id], 'current') && orderListItemRef[id].current){
            orderListItemRef[id].current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
        }
    }
}

SelectableOrderInfo.defaultProps = {
    showPhoneNumber: false,
    staffOrders: {},
    loading: false,
    areaExpanded: false
}

export default SelectableOrderInfo